import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Variant } from '../models';
@Component({
  selector: 'app-variant-list',
  templateUrl: './variant-list.component.html',
  styleUrls: ['./variant-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariantListComponent implements OnInit {
  @Input() variants: Variant[];

  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/variant-list/variant-list.component.ts